import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "./PdfViewer-orizzontal.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfViewer = ({ pdf }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const scale = 5;

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const nextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 2);
    }
  };

  const prevPage = () => {
    if (pageNumber > 2) {
      setPageNumber(pageNumber - 2);
    }
  };


  function setpage(){
    // Now we can access the #test element on the other page
    const testDiv = Number(document.getElementById('cerca').value);
    setPageNumber(testDiv);
  };

  return (
    <div>
      <div className="controls"style={{marginRight: '180px'}}>
        <button className="button-62" onClick={prevPage} disabled={pageNumber < 3}>
        Precedente
        </button>
        <button className="button-62" onClick={nextPage} disabled={pageNumber === numPages}>
        Successiva
        </button>
        <button className="button-62" onClick={setpage}>cerca pagina</button>
      </div>
      <Document
        file={pdf}
        onLoadSuccess={onDocumentLoadSuccess}
        onContextMenu={(e) => e.preventDefault()}
        className="pdf-container"
      >
        <div className="pdf-pages-container">
          {/* Render the current page and the next page */}
          <div className="pdf-page">
            <Page pageNumber={pageNumber} scale={scale} renderAnnotationLayer={false} renderTextLayer={false} />
          </div>
          {pageNumber < numPages && (
            <div className="pdf-page">
              <Page pageNumber={pageNumber + 1} scale={scale} renderAnnotationLayer={false} renderTextLayer={false} />
            </div>
          )}
        </div>
      </Document>
    </div>
  );
};

export default PdfViewer;